var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPageMyCards(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 25,
    viewBox: "0 0 22 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.83301 8.16457H20.1663M5.49967 16.3297H9.16634M12.833 16.3297H16.4997M4.76634 20.4122H17.233C18.2598 20.4122 18.7732 20.4122 19.1653 20.1897C19.5103 19.994 19.7908 19.6817 19.9665 19.2976C20.1663 18.861 20.1663 18.2894 20.1663 17.1462V7.34807C20.1663 6.20485 20.1663 5.63324 19.9665 5.19658C19.7908 4.81249 19.5103 4.50022 19.1653 4.30452C18.7732 4.08203 18.2598 4.08203 17.233 4.08203H4.76634C3.73958 4.08203 3.2262 4.08203 2.83403 4.30452C2.48906 4.50022 2.2086 4.81249 2.03283 5.19658C1.83301 5.63324 1.83301 6.20485 1.83301 7.34807V17.1462C1.83301 18.2894 1.83301 18.861 2.03283 19.2976C2.2086 19.6817 2.48906 19.994 2.83403 20.1897C3.2262 20.4122 3.73958 20.4122 4.76634 20.4122Z",
    stroke: "#2828F0",
    strokeWidth: 1.67,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPageMyCards);
export default __webpack_public_path__ + "static/media/pageMyCards.0122ff205f0898c6686ca88279013751.svg";
export { ForwardRef as ReactComponent };